import React from "react";
import AppShell from "../components/layout/AppShell";
import AppFooter from "../components/layout/AppFooter";
import TopNav from "../components/layout/TopNav";

export default function Privacy({ onNavigate, isLoggedIn, onLogout }) {
    return (
        <AppShell
            header={<TopNav isLoggedIn={isLoggedIn} onLogout={onLogout} onNavigate={onNavigate} />}
            footer={<AppFooter onNavigate={onNavigate} />}
            onNavigate={onNavigate}
        >
            <div style={{ maxWidth: 780, margin: "0 auto", padding: "40px 24px 80px" }}>
                <button
                    onClick={() => onNavigate("home")}
                    style={{
                        background: "none", border: "none", color: "rgba(180,180,200,0.75)",
                        fontSize: 13, cursor: "pointer", padding: 0, marginBottom: 28,
                        display: "flex", alignItems: "center", gap: 6,
                    }}
                >
                    ← Retour
                </button>

                <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.025em", marginBottom: 6 }}>
                    Politique de confidentialité
                </h1>
                <p style={{ color: "rgba(180,180,200,0.65)", fontSize: 13, marginBottom: 48 }}>
                    Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
                </p>

                {[
                    {
                        title: "1. Responsable du traitement",
                        content: [
                            "Le responsable du traitement des données personnelles collectées sur le site solvya est :",
                            "Raison sociale : [SAS solvya]",
                            "Email : contact@solvya.io",
                            "Adresse : [À COMPLÉTER]",
                        ]
                    },
                    {
                        title: "2. Données collectées",
                        content: [
                            "Dans le cadre de l'utilisation de la plateforme Solvya, nous collectons les données suivantes :",
                            "— Données d'identification : nom, prénom, adresse email, mot de passe chiffré.",
                            "— Données de paiement : identifiant client Stripe, identifiant de moyen de paiement (aucune donnée bancaire brute n'est stockée sur nos serveurs).",
                            "— Données d'utilisation : tickets créés, sessions effectuées, durée des interventions, historique des échanges.",
                            "— Données de CV (techniciens) : contenu du CV soumis, score IA, compétences détectées.",
                            "— Données de connexion : adresse IP, type de navigateur, horodatage des connexions.",
                        ]
                    },
                    {
                        title: "3. Finalités du traitement",
                        content: [
                            "Les données collectées sont utilisées pour les finalités suivantes :",
                            "— Fourniture du service : mise en relation clients et techniciens, gestion des sessions à distance.",
                            "— Facturation et paiement : calcul et prélèvement automatique des montants dus.",
                            "— Qualité et sécurité : scoring des techniciens, détection de comportements frauduleux, audit des sessions.",
                            "— Communication : envoi de notifications liées au service (confirmation de ticket, fin de session).",
                            "— Obligations légales : conservation des données de facturation conformément aux obligations comptables.",
                        ]
                    },
                    {
                        title: "4. Base légale des traitements",
                        content: [
                            "— Exécution du contrat : traitements nécessaires à la fourniture du service.",
                            "— Consentement : collecte de données non essentielles au service.",
                            "— Obligation légale : conservation des données de facturation (10 ans).",
                            "— Intérêt légitime : sécurité de la plateforme, détection de fraudes.",
                        ]
                    },
                    {
                        title: "5. Durée de conservation",
                        content: [
                            "— Données de compte : conservées pendant toute la durée d'activité du compte, puis supprimées dans un délai de 3 ans après la dernière connexion.",
                            "— Données de facturation : conservées 10 ans conformément aux obligations légales.",
                            "— Données de session : conservées 12 mois à des fins de sécurité et de résolution de litiges.",
                            "— CV techniciens : conservés pendant toute la durée d'activité du compte technicien.",
                        ]
                    },
                    {
                        title: "6. Partage des données",
                        content: [
                            "Solvya ne vend aucune donnée personnelle à des tiers. Les données peuvent être partagées avec :",
                            "— Stripe (paiement) : traitement sécurisé des paiements, conforme PCI-DSS.",
                            "— OpenAI (IA) : analyse des CV et diagnostics. Les données sont transmises de manière chiffrée et ne sont pas utilisées pour entraîner les modèles.",
                            "— Hébergeur : OVH — stockage des données sur des serveurs situés en Suisse.",
                        ]
                    },
                    {
                        title: "7. Sécurité des données",
                        content: [
                            "Solvya met en œuvre les mesures techniques et organisationnelles suivantes pour protéger vos données :",
                            "— Chiffrement des communications (HTTPS/TLS).",
                            "— Chiffrement des mots de passe (bcrypt).",
                            "— Accès aux données restreint au personnel autorisé.",
                            "— Sessions d'accès à distance sécurisées via WebRTC chiffré.",
                            "— Aucune donnée bancaire brute stockée sur nos serveurs.",
                        ]
                    },
                    {
                        title: "8. Vos droits",
                        content: [
                            "Conformément au RGPD, vous disposez des droits suivants :",
                            "— Droit d'accès : obtenir une copie de vos données personnelles.",
                            "— Droit de rectification : corriger des données inexactes.",
                            "— Droit à l'effacement : demander la suppression de vos données.",
                            "— Droit à la portabilité : recevoir vos données dans un format structuré.",
                            "— Droit d'opposition : vous opposer à certains traitements.",
                            "— Droit de limitation : demander la limitation du traitement de vos données.",
                            "Pour exercer ces droits, contactez-nous à : contact@solvya.io.",
                            "Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr).",
                        ]
                    },
                    {
                        title: "9. Cookies",
                        content: [
                            "Le site solvya utilise uniquement des cookies strictement nécessaires au fonctionnement du service :",
                            "— Cookie de session : maintien de votre connexion.",
                            "— Token d'authentification JWT : stocké en localStorage.",
                            "Aucun cookie publicitaire, analytique tiers ou de tracking n'est utilisé.",
                        ]
                    },
                    {
                        title: "10. Contact",
                        content: [
                            "Pour toute question relative à la présente politique de confidentialité ou pour exercer vos droits :",
                            "Email : [contact@solvya.io]",
                            "Adresse : [À COMPLÉTER]",
                        ]
                    },
                ].map((section) => (
                    <div key={section.title} style={{ marginBottom: 40 }}>
                        <h2 style={{
                            fontSize: 16, fontWeight: 700, letterSpacing: "-0.01em",
                            marginBottom: 14, paddingBottom: 10,
                            borderBottom: "1px solid rgba(255,255,255,0.07)"
                        }}>
                            {section.title}
                        </h2>
                        {section.content.map((line, i) => (
                            <p key={i} style={{
                                fontSize: 14, lineHeight: 1.7,
                                color: line.includes("[À COMPLÉTER")
                                    ? "rgba(245,158,11,0.85)"
                                    : "rgba(200,200,215,0.85)",
                                margin: "0 0 8px",
                            }}>
                                {line}
                            </p>
                        ))}
                    </div>
                ))}
            </div>
        </AppShell>
    );
}